/**
 * Initialize and handle the event filters
 * @type {EventFilter}
 */
export class EventFilter {
    /**
     * constructor for single calendar
     */
    constructor() {
        this.calendar = document.querySelector('.js__calendar')

        if (this.calendar !== null) {
            this.locationFilter = this.calendar.querySelector('.js__location-filter')
            this.formatFilter = this.calendar.querySelector('.js__format-filter')

            this.allEvents = this.calendar.querySelectorAll('.js__calendar-event')

            // initialize events
            if (this.locationFilter && this.formatFilter) {
                this.initializeFilters()
            }
        }
    }

    /**
     * Initialize the filters and add event listeners
     */
    initializeFilters() {
        const _this = this

        // change listener to filter list
        this.locationFilter.querySelector('select').addEventListener('change', function (e) {
            _this.handleFilterValue('location', this.selectedOptions[0].value)
        })

        this.formatFilter.querySelector('select').addEventListener('change', function () {
            _this.handleFilterValue('format', this.selectedOptions[0].value)
        })
    }

    handleFilterValue(filter, value) {
        if (filter === 'format') {
            this.selectedFormat = value
        } else {
            this.selectedLocation = value
        }

        this.showFilteredEvents()
    }

    showFilteredEvents() {
        // calendar-monthly-events > calendar-monthly-events__columns-wrapper > calendar-monthly-events__not-found

        if (this.selectedFormat || this.selectedLocation) {
            // add filter-active class for calender to change appearance
            this.calendar.classList.add('calendar-events--filtered')

            // used to change appearance of the events
            let isEven = false
            // hide all, check for matching of format and location
            for (let event of this.allEvents) {
                let matched = false

                // matched if
                if (event.dataset.filterFormat == this.selectedFormat || !this.selectedFormat) {
                    matched = true
                }

                // (ignore selected location on events with no given location)
                // revoke matched if location is set but not match
                if (
                    this.selectedLocation &&
                    event.dataset.filterLocation &&
                    event.dataset.filterLocation != this.selectedLocation
                ) {
                    matched = false
                }

                // show event if matched
                if (matched) {
                    event.classList.add('event--show')
                    event.dataset.appearance = isEven ? 'even' : 'odd'
                    isEven = !isEven
                } else {
                    event.classList.remove('event--show')
                }
            }
            this.checkForFoundResultsEachMonth()
        } else {
            // when no filter of all selects are given go back to normal appearance
            this.checkForFoundResultsEachMonth(true)
            // remove filter-active class for calender to change appearance
            this.calendar.classList.remove('calendar-events--filtered')
        }
    }

    // go through every month and check if there is any shown event, if not show message and vise versa
    checkForFoundResultsEachMonth(reset) {
        const months = this.calendar.querySelectorAll('.calendar-monthly-events')
        for (let month of months) {
            // element to show or hide
            let notFoundText = month.querySelector('.calendar-monthly-events__not-found')
            // check HTML element to prevent errors
            if (notFoundText === null) continue
            // if any event is shown within month remove show no results else vise versa
            if (month.querySelector('.event--show') != null || reset === true) {
                notFoundText.classList.remove('show-no-results')
            } else {
                notFoundText.classList.add('show-no-results')
            }
        }
    }
}
